import React from 'react';
import { Typography } from '@/components/Typography/Typography';
import { Container } from '@/components/Containers/Container';
import Image from 'next/image';

export const SecondSection = () => {
  return (
    <section className="relative bg-white">
      <Container className="md:pt-24.5-vw md:pb-24.5-vw pt-15 pb-15">
        <div className="flex items-center flex-col lg:gap-10-vw gap-4">
          <Typography $type="PSmall" className="font-formula text-center max-md:block hidden">
            <i>In search of Freshdesk integrations?</i>
          </Typography>
          <Typography as="h2" $type="Heading3Big" className="font-formula text-center md:w-8/12">
            In search of Freshdesk integrations? Benefit from a ready-to-go AI Assistant for
            Freshdesk
          </Typography>
          <div className="flex items-stretch w-full max-lg:flex-col justify-between lg:gap-6-vw gap-4">
            <div className="flex w-full justify-center items-center max-lg:flex-col flex-1 lg:px-8-vw lg:py-10-vw px-7 py-10 lg:gap-5-vw gap-5 rounded-lg border border-loblolly border-opacity-50">
              <div>
                <Image
                  alt="freshdesk-integration-icon-3"
                  src={'/img/freshdesk-integration/freshdesk-integration-icon-3.webp'}
                  width="365"
                  height="365"
                  className="lg:min-w-[4.861vw] lg:max-w-[4.861vw] max-w-[70px]"
                />
              </div>
              <div>
                <Typography
                  $type="PRegular"
                  className="font-jamjuree max-lg:text-center"
                  $weight="500"
                >
                  <i>Automate up to 75% of responses</i>
                </Typography>
              </div>
            </div>
            <div className="flex w-full justify-center items-center max-lg:flex-col flex-1 lg:px-8-vw lg:py-10-vw px-7 py-10 lg:gap-5-vw gap-5 rounded-lg border border-loblolly border-opacity-50">
              <div>
                <Image
                  alt="freshdesk-integration-icon-4"
                  src={'/img/freshdesk-integration/freshdesk-integration-icon-4.webp'}
                  width="255"
                  height="255"
                  className="lg:min-w-[4.861vw] lg:max-w-[4.861vw] max-w-[70px]"
                />
              </div>
              <div>
                <Typography
                  $type="PRegular"
                  className="font-jamjuree max-lg:text-center"
                  $weight="500"
                >
                  Get a 68% Rise in Freshdesk Ticket Resolution
                </Typography>
              </div>
            </div>
            <div className="flex w-full justify-center items-center max-lg:flex-col flex-1 lg:px-8-vw lg:py-10-vw px-7 py-10 lg:gap-5-vw gap-5 rounded-lg border border-loblolly border-opacity-50">
              <div>
                <Image
                  alt="freshdesk-integration-icon-1"
                  src={'/img/freshdesk-integration/freshdesk-integration-icon-1.webp'}
                  width="334"
                  height="334"
                  className="lg:min-w-[4.861vw] lg:max-w-[4.861vw] max-w-[70px]"
                />
              </div>
              <div>
                <Typography
                  $type="PRegular"
                  className="font-jamjuree max-lg:text-center"
                  $weight="500"
                >
                  <i>Accelerate Ticket Processing by 80%</i>
                </Typography>
              </div>
            </div>
            <div className="flex w-full justify-center items-center max-lg:flex-col flex-1 lg:px-8-vw lg:py-10-vw px-7 py-10 lg:gap-5-vw gap-5 rounded-lg border border-loblolly border-opacity-50">
              <div>
                <Image
                  alt="earth-icon"
                  src={'/img/freshdesk-integration/earth-icon.webp'}
                  width="210"
                  height="210"
                  className="lg:min-w-[4.861vw] lg:max-w-[4.861vw] max-w-[70px]"
                />
              </div>
              <div>
                <Typography
                  $type="PRegular"
                  className="font-jamjuree max-lg:text-center"
                  $weight="500"
                >
                  <i>Use 30+ language to provide support worldwide</i>
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
